// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "NetworthSummarySection__body__JUfV- font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const section = "NetworthSummarySection__section__ie1hP";
export const semibold = "600";
export const serif = "'serif'";
export const switchButton = "NetworthSummarySection__switchButton__QwcGU";
export const switchButtonWrapper = "NetworthSummarySection__switchButtonWrapper__Bk5ti";
export const title = "NetworthSummarySection__title__Vk9mk";